<template>
    <div class="pos-v3-container">
        <!-- Main Content Card -->
        <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6">
            <Header :title="$t('pos.title')" />

            <!-- Table Component -->
            <POSTable :user-id="userId" :token="token" />
        </div>
    </div>
</template>

<script>
import POSTable from './POSTable.vue'
import normalizeSize from '../../../utils/normalizeSize'
import normalizeFontSize from '../../../utils/normalizeFontSize'
import Header from '../../Shared/Header.vue'

export default {
    name: 'BoPOSV3Index',
    components: {
        POSTable,
        Header,
    },
    props: {
        userId: {
            type: [Number, String, null],
            default: null,
        },
        token: {
            type: String,
            default: '',
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
    mounted() {
        const mainContainer = document.getElementById('main-container')
        if (mainContainer) {
            mainContainer.classList.add('pos-v3-no-bg')
        }
    },
    beforeDestroy() {
        const mainContainer = document.getElementById('main-container')
        if (mainContainer) {
            mainContainer.classList.remove('pos-v3-no-bg')
        }
    },
}
</script>

<style scoped lang="scss">
.pos-v3-container {
    padding: 0;
}
</style>

<style lang="scss">
#main-container.pos-v3-no-bg {
    background: transparent !important;
    border-radius: 0px;
}
</style>
